import React, {Component, PureComponent} from 'react';
import { Help } from '@mui/icons-material';
import Slider from '@mui/material/Slider';
import parse from 'html-react-parser';


class SliderItemOne extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        answerIds: [],
        initValue: 1,
        prepopLoaded: false
      };
      this.sliderOnChange = this.sliderOnChange.bind(this)
      this.calculateInitValue = this.calculateInitValue.bind(this)
    }

    componentDidMount = () => {
        var newObj = [];

        if(this.props.data.answerOptions) {
            this.props.data.answerOptions.map((x) => {
                newObj.push({
                    "id": x.id
                });
            })
            this.setState({ answerIds: newObj });
            
            if(this.props.prepop && this.props.prepop.hasOwnProperty('answers') && !this.state.prepopLoaded) {
                
                let prePopedAnswer = this.props.prepop.answers
                
                
                if(prePopedAnswer && prePopedAnswer.length > 1) {
                    prePopedAnswer = prePopedAnswer.slice(prePopedAnswer.length -1)
                }
                
                var initialData = {
                    "id": this.props.data.id,
                    "answers": [
                        {
                            "id":  prePopedAnswer.hasOwnProperty('id') ? prePopedAnswer.id : this.mapValueToId(0.5),
                            "text": (prePopedAnswer.hasOwnProperty('answers') && prePopedAnswer[0].text) || '5'
                        }
                    ]
                };
                
                this.setState({initValue: (prePopedAnswer) ? parseInt(prePopedAnswer[0].text)  : 1, prepopLoaded: true}, ()=>{
                    this.props.sliderData(initialData)
                })
            }
        
        }
        
    }

    mapValueToId = (value) => {

        if(this.state.answerIds.length > 0) {
            if((value) >= 0) {
                return this.state.answerIds[value].id
            }
            else {
                return this.state.answerIds[0].id
            }
        }
        return 
    }

    sliderOnChange = (e, item) => {
        var data = {
            "id": this.props.data.id,
            "answers": [
                {
                    "id": this.mapValueToId(item),
                    "text": "" + this.props.data.answerOptions.find((ans) => {
                        return this.mapValueToId(item) === ans.id
                     }).text
                }
            ],
            "questionText": this.props.data.text
        };
     
        this.props.sliderData(data)

    }

    renderAxisText(answers) {
        let output = ""
        
        if(answers.length === 10) {
            answers.forEach((item, num) => {
                if(num === 0 || num === 4 || num === 9) {
                    output += "<p className='slider-axis'>"+ item.text + "</p>"
                }
            })
        }

        return output
    }
  
    calculateInitValue = () => {
        if(this.props.prepop) {
            let prePopedAnswer = this.props.prepop.hasOwnProperty('questions') && this.props.prepop.questions.find((item) =>{
                return item.id === this.props.data.id
            })
    
            if(prePopedAnswer && prePopedAnswer.length > 1) {
                prePopedAnswer = prePopedAnswer[prePopedAnswer.length -1]
            }
           if(prePopedAnswer && prePopedAnswer.hasOwnProperty('answers')) {
                return parseInt(prePopedAnswer.answers[0].text) 
            }
        }
        
        return 1
    }

    render() {
        let item = this.props.data;
        //let initValue = this.calculateInitValue()
        return (
            <div className='slider-wrapper'>
                <div className='slider-left'>
                    <label>{item.text}
                        <span className='tooltip'><Help /><p>{item.description}</p></span>
                    </label>
                </div>
                <div className='slider-right' id={this.props.sliderName}>
                    <Slider step={1} min={0} max={10} defaultValue={this.state.initValue} id={this.props.sliderName} name={this.props.sliderName} onChange={this.sliderOnChange} />
                </div>
                <div className='slider-axis-wrapper items--3'>
                {
                    parse(this.renderAxisText(item.answerOptions))
                }
                    
                </div>
            </div>
        );
    }
}

class SliderItemTwo extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        answerIds: [],
        initValue: 0.0,
        prepopLoaded: false
      };
      this.sliderOnChange = this.sliderOnChange.bind(this)
      this.calculateInitValue = this.calculateInitValue.bind(this)
    }

    componentDidMount = () => {
        var newObj = [];
        
        this.props.data.answerOptions.map((x) => {
            newObj.push({
                "id": x.id
            });
        })
        
        this.setState({ answerIds: newObj });

        if(this.props.prepop && this.props.prepop.hasOwnProperty('answers') && !this.state.prepopLoaded) {

            let prePopedAnswer = this.props.prepop.answers
       
        if(prePopedAnswer && prePopedAnswer.length > 1) {
            prePopedAnswer = prePopedAnswer.slice(prePopedAnswer.length -1)
        }
        
        var data = {
            "id": this.props.data.id,
            "actualValue": (prePopedAnswer[0].hasOwnProperty('text') && prePopedAnswer[0].text) || 0,
            "answers": [
                {
                    "id": prePopedAnswer[0].hasOwnProperty('id') ? prePopedAnswer[0].id : this.mapValueToId(0),
                    "text": (prePopedAnswer[0].hasOwnProperty('text') && prePopedAnswer[0].text) || 0
                }
            ]
        };
        
        this.setState({initValue: (prePopedAnswer) ? parseFloat(prePopedAnswer[0].text)  : 0, prepopLoaded: true}, ()=>
        {
            this.props.sliderData(data)
        })
    }
        
    }

    mapValueToId = (value) => {
        let adjustedValue = value;

        if(this.state.answerIds.length > 0) {
            return this.state.answerIds[adjustedValue].id
        }
        else {
            return this.state.answerIds[0].id
        }
        return 0
    }

    sliderOnChange = (e, item) => {
        var data = {
            "id": this.props.data.id,
            "actualValue": (parseFloat(item)),
            "answers": [
                {
                    "id": this.mapValueToId(item),
                    "text": "" + (parseFloat(item))
                }
            ],
            "questionText": this.props.data.text
        };
     
        this.props.sliderData(data)
    }
  
    renderAxisText(answers) {
        let output = ""

        if(answers.length === 21) {
            answers.forEach((item, num) => {
                if(num === 0 || num === 5 || num === 10 || num === 15 || num === 20) {
                    output += "<p className='slider-axis'>"+ item.text + "</p>"
                }
            })
        }

        return output
    }

    calculateInitValue = () => {
       
        if(this.props.prepop) {
            let prePopedAnswer = this.props.prepop.hasOwnProperty('questions') && this.props.prepop.questions.find((item) =>{
                return item.id === this.props.data.id
            })
    
            if(prePopedAnswer && prePopedAnswer.length > 1) {
                prePopedAnswer = prePopedAnswer[prePopedAnswer.length -1]
            }
    
           if(prePopedAnswer && prePopedAnswer.hasOwnProperty('answers')) {
                return parseFloat(prePopedAnswer.answers[0].text)
           }
            
        }

        return 0
    }

    render() {
        let item = this.props.data;
        return (
            <div className='slider-wrapper'>
                <div className='slider-left'>
                    {this.props.questionLength > 1 ? <label>{item.text}</label> : undefined }
                </div>
                <div className='slider-right' id={this.props.sliderName}>
                    <Slider step={1} defaultValue={this.state.initValue} id={this.props.sliderName} min={0} max={20} marks={true} name={this.props.sliderName} onChange={this.sliderOnChange} />
                </div>
                <div className='slider-axis-wrapper'>
                {
                    parse(this.renderAxisText(item.answerOptions))
                }
                    
                </div>
            </div>
        );
    }
}

export default class SurveySlider extends PureComponent {
    constructor (props) {
        super(props)
        this.state = {
            sliderArray: [],
            prepopAnswers: {},
            questions: -1,
            prevAnswers: []
        }
    }

    componentDidMount = () => {
        this.setState({questions: this.props.data.questions.length, 
        sliderArray: this.props.data.questions})
    }

    sliderValidation = () => {
        var sliderArraySize = this.state.questions;
        if (this.state.sliderArray.length === sliderArraySize) {
            return true
        }
        return false
    }

    sliderData = (item) => {
        var newArray = Object.assign([],this.state.sliderArray);
        var foundIndex = -1
        if(newArray.length === this.state.questions) {
            foundIndex = newArray.findIndex((x, i) => {
                return item.id === x.id
            })
            if(foundIndex > -1) {
                newArray[foundIndex] = item
            }
        }
        else {
            newArray.push(item)
        }

        this.setState({ sliderArray: newArray });
        var valid = this.sliderValidation() ? true: false;
        var newData = {
            "questionNumber": this.props.questionNumber,
            "valid": valid,
            "id": this.props.data.id,
            "questions": newArray
        };
        this.props.manageFormData(newData);
    }

    handleSliderItemChange = updatedSlider => {
      const newArray = this.state.sliderArray
        .map(existingSlider => {
          if (updatedSlider.id === existingSlider.id) {
            return updatedSlider
          }

          return existingSlider
        })
        .map(slider => {
          if (!slider.answers && slider.answerOptions && slider.answerOptions.length > 0) {
            const defaultAnswer = slider.answerOptions[0]

            return {
              ...slider,
              actualValue: defaultAnswer.text,
              answers: [
                {
                  id: defaultAnswer.id,
                  text: defaultAnswer.text,
                  questionText: slider.text,
                }
              ]
            }
          }

          return slider
        })

      this.setState({ sliderArray: newArray });
      var valid = this.sliderValidation() ? true: false;
      var newData = {
        "questionNumber": this.props.questionNumber,
        "valid": valid,
        "id": this.props.data.id,
        "questions": newArray
      };
      this.props.manageFormData(newData);
    }

    hashCode = (value) => {
        return value.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);              
    }

    render() {
        var questionLength = this.props.data.questions.length;

        if (this.props.data.questions.length) {
            var output = this.props.data.questions.map((x, i) => {
                //var sliderName = (this.hashCode(x.text) + i).toString() // generate random name
                // update to use question type
                // need to update because getting the data from the props causes redraw
                // it send the questions up, and then when they come back down they get newIDs
                let prepop = this.props.prepop.hasOwnProperty('questions') && this.props.prepop.questions[i]


                if (parseInt(x.questionType) === 3) {
                    return (
                        <SliderItemOne key={`survery-slider-item-one-${x.id}-${x.questionGroupID}-${x.orderDisplay}`} data={x} sliderName={x.id} sliderData={this.sliderData} prepop={prepop} />
                    )
                }
                return (
                    <SliderItemTwo key={`survery-slider-item-one-${x.id}-${x.questionGroupID}-${x.orderDisplay}`} data={x} sliderName={x.id} sliderData={this.handleSliderItemChange} questionLength={questionLength} prepop={prepop}  />
                )
                
            })
        }

    return (
        <div>
            <h3 className='question-title'>{this.props.data.title}</h3>
            <div className='slider-wrapper-parent'>
                {output}
            </div>
        </div>
    )
  }
}
